import { useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import AdministrationMenu from "../nav/NavSidebar/AdministrationMenu"
import useSidebarContent from "../hooks/useSidebarContent"
import logo from "../assets/images/logo-white-text.png"

import styles from "../styles/Nav-Sidebar.module.css"

export default function Sidebar({
  isCollapsed = false,
  isOverlayOpen = false,
  onOverlayMouseEnter = () => {},
  onOverlayMouseLeave = () => {},
}) {
  const { content: contextualContent } = useSidebarContent()
  const previousOverlayOpenRef = useRef(isOverlayOpen)

  // When collapsed sidebar closes, fire an outside click so open popup panels close
  useEffect(() => {
    if (isCollapsed && previousOverlayOpenRef.current && !isOverlayOpen) {
      if (typeof document !== "undefined" && typeof MouseEvent === "function") {
        const eventView = document.defaultView || null
        const mouseDownEvent = new MouseEvent("mousedown", {
          bubbles: true,
          cancelable: true,
          view: eventView,
        })
        const clickEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: eventView,
        })

        document.dispatchEvent(mouseDownEvent)
        document.dispatchEvent(clickEvent)
      }
    }
    previousOverlayOpenRef.current = isOverlayOpen
  }, [isCollapsed, isOverlayOpen])

  return (
    <div
      className={`${styles.sidebarShell} ${
        isCollapsed ? styles.isCollapsed : styles.isExpanded
      } ${isOverlayOpen ? styles.isOverlayOpen : ""}`}
    >
      <aside
        className={styles.sidebar}
        aria-label="Global sidebar"
        onMouseEnter={onOverlayMouseEnter}
        onMouseLeave={onOverlayMouseLeave}
        onPointerDownCapture={onOverlayMouseEnter}
        onFocusCapture={onOverlayMouseEnter}
      >
        <div className={styles.scrollRegion}>
          {contextualContent ? (
            <div className={styles.contextualSection}>{contextualContent}</div>
          ) : null}
        </div>

        <div className={styles.bottomPinnedSection}>
          <div className={styles.bottomMenuScrollArea}>
            <AdministrationMenu />
          </div>
          <div className={styles.appLogoFooter}>
            <Link to="/" className={styles.appLogoLink} aria-label="Go to dashboard">
              <img
                src={logo}
                alt="Recovery Link Logo"
                className={styles.appLogoImage}
              />
            </Link>
          </div>
        </div>
      </aside>
    </div>
  )
}
